import { API } from "../../../../utils/api";

export async function getDevicesAPI() {
  return (await API.get(`v2/lease/model`)).data
}

export async function getRiderInspectionAPI(modelType) {
  return (await API.get(`lease/rider/inspection?modelType=${modelType}`)).data
}